// extracted by mini-css-extract-plugin
export default {"title":"PoweredByIgnosis_title__ewHxx"};